module.exports = __webpack_public_path__ + "static/img/partner.f629ae9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/pic/partner.png
// module id = iWL0
// module chunks = 11